module.exports = __webpack_public_path__ + "static/media/wa.89772ec0.png";